import script from "./HistoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryView.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./HistoryView.vue?vue&type=style&index=1&id=18d9a140&lang=scss"

const __exports__ = script;

export default __exports__